export default "__VITE_ASSET__42b9961f__"